import i18n from "lib/i18n";
import $ from "jquery";
import { debounce, each } from "lodash";
/* eslint-disable
    camelcase,
    class-methods-use-this,
    consistent-return,
    constructor-super,
    func-names,
    guard-for-in,
    max-len,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-new,
    no-restricted-syntax,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import pym from "pym.js";
import Minpubsub from "minpubsub";
import ResponsiveVideos from "lib/tc/responsive_videos";
import SocialButtonView from "views/social_button_view";
import Infographics from "lib/tc/infographics";
import Imagebox from "lib/imagebox";
import BasePage from "pages/base_page";
import CommentsSectionView from "views/comments_section_view";
import RepublicationView from "views/republication_view";
import initializeContentBody from "lib/content_body";

import React from "react";
import ReactDOM from "react-dom";
import PodcastListenAndSubscribe from "containers/PodcastListenAndSubscribe";
import RelatedArticles from "components/Content/RelatedArticles/Loader";
import renderEditorialMenu from "lib/renderEditorialMenu";
import renderPromos from "../renderPromos";
import { eventBus } from "../utils";
import { track } from "../lib/analytics";

const EDITORIAL_ACTIONS_MENU_PATH = "/editorial/actions_menu/content/:content_id";

let ContentPage;

export default ContentPage = (function () {
  ContentPage = class ContentPage extends BasePage {
    static initClass() {
      this.prototype.events = {
        "click form.edit-user input[type=checkbox]": "checkNotificationSettings",
        "click li.print a": "printArticle",
        "click aside.content-social-distribution li a": "shareClickTracking",
        "click textarea.stolen-body": "selectStolenBody",
        "click .content-translations .content-translations-toggle": "_toggleTranslationSidebar",
        "click .content-authors .content-authors-toggle": "_toggleArticleSidebar",
      };
    }

    initialize(options) {
      super.initialize(options);

      this.closeComments = this.closeComments.bind(this);
      this.openComments = this.openComments.bind(this);
      this._toggleArticleSidebar = this._toggleArticleSidebar.bind(this);
      this._toggleTranslationSidebar = this._toggleTranslationSidebar.bind(this);

      if (navigator.platform.indexOf("iPhone") === -1) {
        new Imagebox($("figure.zoomable > a"));
      }

      new ResponsiveVideos();

      this.trackScrolling();

      this.initResponsiveFrames();
      Infographics.init(this.$el);

      Minpubsub.subscribe("comments:count:updated", this.updateCommentCount);
      Minpubsub.subscribe("comments:close", this.closeComments);
      Minpubsub.subscribe("comments:open", this.openComments);

      this.commentsClosedAt = options.comments_closed_at;
      this.content_slug = options.content_slug;
      this.content_id = options.content_id;

      this.commentsSectionView = new CommentsSectionView({
        commentsClosedAt: this.commentsClosedAt,
        content_id: this.content_id,
      });
      this.commentsSectionView.$el.appendTo($("#comments-container"));

      this.initShareButtons();
      this.initPrintButton();
      this.initContentBody();

      this.initListenAndSubscribe(options);

      const {
        collaborator_ids: collaboratorIds,
        section_ids: sectionIds,
        topic_ids: topicIds,
      } = options;
      const promosContext = { content: { collaboratorIds, sectionIds, topicIds } };
      renderPromos(promosContext);

      if (typeof IntersectionObserver === "undefined") {
        this.renderRelatedContent();
      } else {
        this.renderRelatedContentWhenViewportVisible();
      }

      renderEditorialMenu(EDITORIAL_ACTIONS_MENU_PATH.replace(":content_id", options.content_id));

      eventBus.subscribe((e) => {
        if (e.type === "republish") {
          this.republish();
        }
      });
    }

    _isUS() {
      return $("body").is(".region_us");
    }

    _isAU() {
      return $("body").is(".region_au");
    }

    _isUK() {
      return $("body").is(".region_uk");
    }

    _isFR() {
      return $("body").is(".region_fr");
    }

    _isAfrica() {
      return $("body").is(".region_africa");
    }

    shareClickTracking(event) {
      const social_network = $(event.currentTarget).closest("li").attr("class");
      track("Article page - share clicks", document.location.pathname, social_network, 1);
    }

    initShareButtons() {
      return $.ajax({
        url: `/share_counts/${this.content_id}`,
        success: (data) => {
          this.$(".twitter-button").each((i, el) => new SocialButtonView({ el, count: data.tweet_count }));

          this.$(".facebook-button").each((i, el) => new SocialButtonView({ el, count: data.facebook_count }));

          return this.$(".linkedin-button").each((i, el) => new SocialButtonView({ el, count: data.linked_in_count }));
        },
      });
    }

    initPrintButton() {
      const printButton = `<li class='print'><a href='#'><i class='icon-print'></i> ${i18n.t("content.button.print")}</a></li>`;
      this.$el.find(".content-social-distribution ul").append(printButton);
      return this.$el.find(".interact-with-this-article ul").append(printButton);
    }

    initContentBody() {
      const node = document.querySelector("div.content-body");
      if (node) initializeContentBody(node);
    }

    initListenAndSubscribe(options) {
      if (document.getElementById("podcast-listen-and-subscribe")) {
        const domContainer = document.createElement("div");
        const subscriptionOptions = document.getElementById("podcast-listen-and-subscribe");
        subscriptionOptions.parentNode.insertBefore(domContainer, subscriptionOptions);

        const container = React.createElement(PodcastListenAndSubscribe, options);

        ReactDOM.render(container, domContainer);
      }
    }

    printArticle(event) {
      event.preventDefault();
      track("Article page - print button clicks", document.location.pathname, "", 1);
      return window.print();
    }

    trackScrolling() {
      // Scroll Tracking
      const pageLoadedAt = new Date();
      if ($("#article").length > 0) {
        const articlePercentVerticalPosition = {};
        const articleHeight = $("#article").height();
        const articleTop = $("#article").offset().top;
        for (let percentOfArticle = 10; percentOfArticle <= 100; percentOfArticle += 10) {
          articlePercentVerticalPosition[percentOfArticle] = ((articleHeight / 100) * percentOfArticle) + articleTop;
        }

        const reportScroll = function () {
          const scrollBottom = $(window).scrollTop() + $(window).height();
          return (() => {
            const result = [];
            for (const percent in articlePercentVerticalPosition) {
              const verticalPosition = articlePercentVerticalPosition[percent];
              if (scrollBottom > verticalPosition) {
                track("Article Page - percent scrolled", document.location.pathname, `${percent}%`, 1);
                if (`${percent}` === "100") {
                  const timeTaken = (new Date() - pageLoadedAt) / 1000;
                  track("Article Page - article scrolled to bottom", document.location.pathname, "timeTaken", timeTaken);
                }
                result.push(delete articlePercentVerticalPosition[percent]);
              } else {
                result.push(undefined);
              }
            }
            return result;
          })();
        };

        const throttleReportScroll = debounce(reportScroll, 50);
        $(window).scroll(throttleReportScroll);
        return reportScroll();
      }
    }

    initResponsiveFrames() {
      const iframes = this.$el.find("iframe[responsive='true']");
      return each(iframes, (iframe, index) => {
        $(iframe).hide();
        $(iframe).before(`<div id='responsive-iframe-${index}'></div>`);
        return new pym.Parent(`responsive-iframe-${index}`, $(iframe).attr("src"), {});
      });
    }

    republish(url) {
      return $.ajax({
        url: url || `/share/${window.location.pathname}`,
        dataType: "text",
        success: (data) => {
          const republicationView = new RepublicationView({
            republishContent: data,
            copyAdvice: this.copy_advice(),
          });
          return republicationView.$el.appendTo(document.body);
        },
      });
    }

    // Build a string containing device-specific advice for copying
    copy_advice() {
      const iPhone = !navigator.platform.indexOf("iPhone");
      const mac = !navigator.platform.indexOf("Mac");
      const copy_key = mac ? "\u2318" : "Ctrl";
      if (iPhone) {
        return i18n.t("content.message.copying_text_on_mobile_device");
      }
      return i18n.t("content.message.key_combination_to_press_to_copy_text", { control_or_command_key: copy_key });
    }

    selectStolenBody(event) {
      return $(event.currentTarget).select();
    }

    // TODO: this should be removed after article comment management is open for all editors
    closeComments() {
      const url = `/editorial/content/${this.content_slug}/close_comments`;
      return $.ajax({
        url,
        type: "PUT",
        success(data) {
          return Minpubsub.publish("comments:closed", [data.comments_closed_at]);
        } });
    }

    // TODO: this should be removed after article comment management is open for all editors
    openComments() {
      const url = `/editorial/content/${this.content_slug}/open_comments`;
      return $.ajax({
        url,
        type: "PUT",
        success(data) {
          return Minpubsub.publish("comments:opened", [data.comments_closed_at]);
        } });
    }

    // These comment count things should probably be backbone views that subscribe to
    // "comment:count:updated" or something
    updateCommentCount(commentsCount) {
      let commentsCountText;
      if (commentsCount !== 1) {
        commentsCountText = i18n.t("comment.label.comment_plural");
      } else {
        commentsCountText = i18n.t("comment.label.comment_singular");
      }

      return $(".comment-count").html(`${commentsCount} ${commentsCountText}`);
    }

    _toggleArticleSidebar(event) {
      event.preventDefault();
      return this.$el.find(".content-sidebar").toggleClass("open");
    }

    _toggleTranslationSidebar(event) {
      event.preventDefault();
      return this.$el.find(".content-translations").toggleClass("open");
    }

    renderRelatedContent() {
      const relatedArticlesEl = document.querySelector(".react-content-related-container");
      if (relatedArticlesEl !== null) {
        const { articleId } = relatedArticlesEl.dataset;
        const relatedArticlesComponent = React.createElement(RelatedArticles, { articleId });
        ReactDOM.render(relatedArticlesComponent, relatedArticlesEl);
      }
    }

    renderRelatedContentWhenViewportVisible() {
      const observedRelatedContentEl = document.querySelector(".react-content-related-container");
      const relatedContentObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.renderRelatedContent();
            observer.disconnect();
          }
        });
      });
      relatedContentObserver.observe(observedRelatedContentEl);
    }
  };

  ContentPage.initClass();
  return ContentPage;
}());
